import { deepMerge } from '@/lib/utils';
import type { Variant, Variants } from 'motion/react';

export const baseVariants: Record<string, Variants> = {
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.4 } },
    exit: { opacity: 0 },
  },
  slideRight: {
    initial: { x: -20, opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.4 } },
    exit: { x: 20, opacity: 0 },
  },
};

export function getVariant(key: string | Variant): Variants {
  const parts = key.toString().split(' ');

  return parts.reduce(
    (acc, part) => {
      const variant = baseVariants[part];

      if (!variant) {
        return acc;
      }

      return {
        initial: deepMerge(acc.initial ?? {}, variant.initial ?? {}),
        animate: deepMerge(acc.animate ?? {}, variant.animate ?? {}),
        exit: deepMerge(acc.exit ?? {}, variant.exit ?? {}),
      };
    },
    { initial: {}, animate: {}, exit: {} },
  );
}
